var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5511 0H0.448934C0.329869 0 0.215681 0.0497259 0.13149 0.138239C0.0472983 0.226751 0 0.3468 0 0.471976L0 15.528C0 15.6532 0.0472983 15.7732 0.13149 15.8618C0.215681 15.9503 0.329869 16 0.448934 16H15.5511C15.6701 16 15.7843 15.9503 15.8685 15.8618C15.9527 15.7732 16 15.6532 16 15.528V0.471976C16 0.3468 15.9527 0.226751 15.8685 0.138239C15.7843 0.0497259 15.6701 0 15.5511 0V0ZM12.5342 11.8796H0.897868V4.12035H15.1021V11.8796H12.5342ZM15.1021 3.1764H12.9832V0.943953H15.1021V3.1764ZM12.0853 3.1764H9.96184V0.943953H12.0853V3.1764ZM9.06397 3.1764H6.94052V0.943953H9.06397V3.1764ZM6.04265 3.1764H3.91919V0.943953H6.04265V3.1764ZM0.897868 0.943953H3.02132V3.1764H0.897868V0.943953ZM0.897868 12.8236H3.02132V15.056H0.897868V12.8236ZM3.91919 12.8236H6.04265V15.056H3.91919V12.8236ZM6.94052 12.8236H9.06397V15.056H6.94052V12.8236ZM9.96184 12.8236H12.0853V15.056H9.96184V12.8236ZM15.1021 15.056H12.9832V12.8236H15.1021V15.056Z",
    fill: "#4D4D4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilm);
export default __webpack_public_path__ + "static/media/film.4fb716d6.svg";
export { ForwardRef as ReactComponent };